<template>
  <div  >
    <!--公司 table tree 列表  start-->
    <el-drawer
      title="导入课程"
      :visible.sync="importDrawer"
      :with-header="false"
      :size="size"
     >
      <el-row class="warp"   >
        <el-col :span="24" class="warp-main"  >
          <!--查询-->
          <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="enterpriseForm" @submit.native.prevent>
              <el-form-item label="企业名称" prop="companyName" >
                <el-input v-model="enterpriseForm.companyName" placeholder="企业名称" style="min-width: 240px;"
                          @keyup.enter.native="handleEnterpriseSearch"></el-input>
              </el-form-item>

              <el-form-item label="平台" prop="platformCode" >
                <el-select v-model="enterpriseForm.platformCode" clearable  placeholder="请选择">
                  <el-option
                      v-for="item in platformList"
                      :key="item.platformCode"
                      :label="item.platformName"
                      :value="item.platformCode">

                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="handleEnterpriseSearch">查询</el-button>
                <el-button type="warning" @click="batchImport"
                           v-if="importEnterpriseRows && importEnterpriseRows.length> 1">批量导入
                </el-button>
              </el-form-item>
            </el-form>
          </el-col>
          <el-table class="enterpriseList"  :data="enterpriseList" row-key="id"
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    @selection-change="enterpriseTableSelectionChange"
                    v-loading="enterpriseLoading" element-loading-text="拼命加载中"
                    height="820">
            <el-table-column
              type="selection"
              width="55"></el-table-column>
            <el-table-column prop="text" label="企业名称" min-width="150" :show-overflow-tooltip="true">
            </el-table-column>
<!--            <el-table-column prop="object.corporateName" label="法人代表" min-width="100">-->
<!--            </el-table-column>-->
            <el-table-column prop="object.platformCodeName" label="平台名称" :show-overflow-tooltip="true" min-width="100">
            </el-table-column>
            <el-table-column prop="object.corporateName" label="状态" min-width="100">
              <template slot-scope="scope">
                <span style="color: #909399" v-if="scope.row.object.importStatus == 0">待导入</span>
                <span style="color: #E6A23C" v-if="scope.row.object.importStatus == 1">导入中...</span>
                <span style="color: #67C23A" v-if="scope.row.object.importStatus == 2">导入成功</span>
                <span style="color: #F56C6C" v-if="scope.row.object.importStatus == 3">导入失败</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button size="mini" type="text"
                           v-if="scope.row.object.importStatus == 0 || scope.row.object.importStatus == 3"
                           @click="improtSingle(scope.row)">导入</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row>
        <el-pagination
            background
            style="margin-top:20px; float:right;"
            @size-change="sizeChange"
            :current-page="enterprisePage"
            @current-change="pageChange"
            :page-sizes="[10,20, 30, 40]"
            :page-size="enterpriseLimit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="enterpriseTotal">
        </el-pagination>
      </el-row>
    </el-drawer>
    <!--公司 table tree 列表  start-->
  </div>
</template>

<script>

import api from "@/api/new/exam.js";
import dataImportApi  from '@/api/training/api_data_import';
import API_Platform from '../../../api/platformManagement/api_platformManagement';
export default {
  name: "trainingPaperImport",
  data(){
    return {
      importDrawer: false,
      enterpriseForm: {
        companyName: "",
        platformCode:""
      },
      size:'40%',
      enterpriseLoading: false,
      //企业列表
      platformList:[],
      enterpriseList: [],
      enterpriseTotal: 0,
      enterprisePage: 1,
      enterpriseLimit: 10,
      currentTrainingPaperId: undefined,
      catalogList: [],
      loading: false,
      tableLoading: true,
      importEnterpriseRows: [],
      importTask: {},  //当前正在进行的导入任务 对象
      refreshAsyncTasksStatusInterval: undefined,
    }
  },
  methods: {
    getPlatformCode(){
      let that = this;
      API_Platform.getPlatformList().then(function (res) {
        that.platformList=res.data;
        console.log(res)
        console.log( that.platformList)


      })
    },

    sizeChange(e) {
      this.enterpriseLimit=e;
      this.enterpriseSearch();
    },
    pageChange(e) {
      this.enterprisePage = e;
      this.enterpriseSearch();
    },
    showImportDrawer(trainingPaperId){
      this.importDrawer = true;
      this.enterpriseTotal = 0;
      this.enterprisePage = 1;
      this.currentTrainingPaperId = trainingPaperId;
      this.enterpriseSearch();
      this.getPlatformCode();
    },
    /**
     * 批量导入
     * */
    batchImport() {
      let importEnterpriseRows = this.importEnterpriseRows
        .filter(item => item.object.importStatus == 0 || item.object.importStatus == 3);
      let enterpriseIds = importEnterpriseRows
        .map(item => item.id);
      if (enterpriseIds.length < 1) {
        this.$message.error("选中的数据没有待导入的数据...");
        return;
      }
      let params = {
        trainingPaperId: this.currentTrainingPaperId,
        enterpriseIds: enterpriseIds.join()
      }
      api.importPaper(params).then(res => {
        this.handleImprotRes(res);
      }, res => {
        console.log(res)
        this.$message.error(res.message);
      });
    },
    /**
     * 单个导入
     * */
    improtSingle: function (row) {
      console.log('import course,  enterpriseId=' + row.id)
      let params = {
        trainingPaperId: this.currentTrainingPaperId,
        enterpriseIds: row.id
      };
      api.importPaper(params).then(res => {
        this.handleImprotRes(res);
      }, res => {
        console.log(res)
        this.$message.error(res.message);
      });
    },
    /**
     *  处理导入课程响应
     **/
    handleImprotRes(res) {
      if (res.code == 0) {
        this.$message.warning("正在导入中.....");
        //将 data import id put 到  importTask 对象当中
        for (const key in res.data.data) {
          this.importTask[res.data.data[key]] = 1;
        }
        this.runRefreshAsyncTasksStatusInterval();
        this.enterpriseSearch();
      } else {
        this.$message.error(res.message);
      }
    },
    enterpriseSearch: function (isCloseLoding) {
      let that = this;
      let params = Object.assign({}, that.enterpriseForm);
      console.log(params)
      params.sourceId = this.currentTrainingPaperId;
      params.page=this.enterprisePage;
      params.limit=this.enterpriseLimit;
      if (!isCloseLoding) {
        that.enterpriseLoading = true;
      }

      dataImportApi.improtEnterprisesRepe(params)
        .then(
          function (result) {
            that.enterpriseLoading = false;
            console.log(result)
            if (result) {
              that.enterpriseList = result.data.objectTrees;
              that.enterpriseTotal=result.data.page.total;
            }
          },
          function (err) {
            that.enterpriseLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    handleEnterpriseSearch() {
      this.enterpriseTotal = 0;
      this.enterprisePage = 1;
      this.enterpriseSearch()
    },
    enterpriseTableSelectionChange(val) {
      this.importEnterpriseRows = val;
      console.log(this.enterpriseIds);
    },
    /**
     * 刷新异步任务状态
     */
    refreshAsyncTasksStatus() {
      // 进行中的任务数组
      let importIds = [];
      for(const key in this.importTask) {
        if (this.importTask[key] == 1) {
          importIds.push(key);
        }
      }
      if (!importIds  || importIds.length < 1)
        return;
      let params = {
        ids:  importIds
      }
      dataImportApi.queryStatus(params).then((res) => {
        if (res.code == 0) {
          let isReload =  false;
          let  resData = res.data.data;
          for(const key in resData) {
            if (resData[key].status != 1) {
              delete this.importTask[key];
              isReload = true;
            }
          }
          if (isReload)
            this.enterpriseSearch(true);
        } else {
          console.error('queryStatus  res:', res.message);
        }
      })
    },
    /**
     * 开启 定时刷新异步任务状态  定时器  （间隔时间 1 秒）
     **/
    runRefreshAsyncTasksStatusInterval() {
      if (this.refreshAsyncTasksStatusInterval) {
        return;
      }
      this.refreshAsyncTasksStatusInterval = window.setInterval(() => {
        this.refreshAsyncTasksStatus();
      }, 1 * 1000)
    },
    /**
     * 关闭刷新异步任务状态
     */
    closeRefreshAsyncTasksStatusInterval() {
      window.clearInterval(this.refreshAsyncTasksStatusInterval);
      this.refreshAsyncTasksStatusInterval = undefined;
    }
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/course/trainingPaperImport.vue